import { InjectionToken } from '@angular/core';

/**
 * Api base url
 */
export const API_BASE_URL = new InjectionToken('Api Base Url');
